// extracted by mini-css-extract-plugin
export var copyable = "_s-2";
export var explainable = "_s-1";
export var negative = "_s-3";
export var positive = "_s-4";
export var secondary = "_s-0";